import { jsx as _jsx } from "react/jsx-runtime";
import bob from '../../assets/bob.png';
import styles from './bobAvatar.module.css';
import clsx from 'clsx';
var BobAvatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'large' : _b;
    return (_jsx("img", { src: bob, className: clsx(styles.image, styles["size__".concat(size)]), alt: 'Bob' }));
};
export default BobAvatar;
